import { CCol, CRow } from '@coreui/react';
import LandingPage from './components/LandingPage';

function App() {
  return (
    <div className='main-form text-center'>
      <header className='headercls'>
        <CRow>
          <CCol xs={12}>
            <h4>EMI Calculator</h4>
            <h6>An intuitive loan EMI calculator with additional repayment feature!</h6>
          </CCol>
        </CRow>
      </header>
      <LandingPage />
    </div>
  );
}

export default App;
